import React, { useState } from 'react';
import { Image, StyleSheet, View } from 'react-native';

export const ResponsiveImage = ({
  uri,
  style,
}: {
  uri: string;
  style?: StyleSheet.NamedStyles<any>;
}) => {
  const [size, setSize] = useState({ width: 0, height: 0 });
  const [desiredHeight, setDesiredHeight] = React.useState(0);

  Image.getSize(uri, (width, height) => {
    setDesiredHeight((size.width / width) * height);
  });

  const styles = StyleSheet.create({
    ...style,
    image: {
      width: '100%',
      height: desiredHeight,
    },
  });

  return (
    <View
      onLayout={(e) => {
        setSize({ ...e.nativeEvent.layout });
      }}
    >
      <Image source={{ uri }} resizeMode="contain" style={styles.image} />
    </View>
  );
};
